import React, { useEffect, useState } from 'react';
import Buttonc from '../../common/button';
import styles from '../property-features/property-features.module.scss';
import { PropertyFeaturesProps } from './property-featuresinterface';
import SkeletonC from '../../common/skeleton';
import FeaturesTag from '../../common/features-tag';
import { numberWithCommas } from '../../../utils/const';
import { SeeAllFeatures } from '../../investor/amplitude';
import { useParams, useSearchParams } from 'react-router-dom';
import useContextHook from '../../../hooks/context/useContext';
const PropertyFeatures = ({
  title,
  objPropertyDetails,
  minShowData,
  loading,
  type,
}: PropertyFeaturesProps) => {
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get('cid') || "";
  const eq = searchParams.get('eq') || "";
  const featuresArray = [
    {
      id: 1,
      num: objPropertyDetails?.beds || objPropertyDetails?.bedRooms,
      label: 'Bedroom',
      icon: '/images/bed.svg',
    },
    {
      id: 2,
      num: objPropertyDetails?.baths || objPropertyDetails?.totalBath,
      label: 'Bathroom',
      icon: '/images/bath.svg',
    },
    {
      id: 3,
      num:
        objPropertyDetails?.sqft > 0
          ? numberWithCommas(objPropertyDetails?.sqft)
          : null,
      label: ' ft²',
      icon: '/images/tape.svg',
    },
    {
      id: 4,
      num:
        objPropertyDetails?.lotSizeSqFt > 0
          ? numberWithCommas(objPropertyDetails?.lotSizeSqFt)
          : null,
      label: ' Lot Size',
      icon: '/images/tape.svg',
    },
    {
      id: 5,
      num: objPropertyDetails?.yearBuilt,
      label: `Built in `,
      icon: '/images/calendar.svg',
    },
    {
      id: 6,
      num: objPropertyDetails?.possession,
      label: '',
      icon: '/images/vacant.svg',
    },
    {
      id: 7,
      num: objPropertyDetails?.occupancy,
      label: '',
      icon: '/images/vacant.svg',
    },
    {
      id: 8,
      num: objPropertyDetails?.propertyAccess,
      label: '',
      icon: '/images/propertyAccess.svg',
    },
  ].filter((feature) => feature.num !== undefined);

  const [showMore, setShowMore] = useState(false);
  const [featData, setFeatData] = useState(() => featuresArray);

  useEffect(() => {
    let _featuresArray;
    if (showMore) {
      setFeatData(featuresArray);
    } else {
      _featuresArray = featuresArray?.slice(0, minShowData);
      setFeatData(_featuresArray);
    }
  }, [objPropertyDetails]);

  function showFeature() {
    setShowMore((prev) => !prev);
    let _featuresArray;
    if (!showMore) {
      // _featuresArray = featuresArray?.slice(0, maxShowData);
      setFeatData(featuresArray);
    } else {
      _featuresArray = featuresArray?.slice(0, minShowData);
      setFeatData(_featuresArray);
    }
  }

  return (
    <div className={styles.propertyFeatures} tabIndex={16}>
      {loading ? (
        <SkeletonC width='50%' height='30px' className='mb-3' />
      ) : (
        <div className={styles.title} tabIndex={17}>
          {title}
        </div>
      )}

      <div className={styles.featuresWrap}>
        {featData?.map((feat: any, index: number) => {
          return (
            <React.Fragment key={index}>
              {loading ? (
                <SkeletonC
                  width='18%'
                  height='45px'
                  className={styles.skeleton}
                />
              ) : (
                <>
                  {(feat.num || feat.url) && (
                    <FeaturesTag
                      value={feat.num}
                      label={feat.label}
                      images={feat.icon}
                      url={feat.url}
                    />
                  )}
                </>
              )}
            </React.Fragment>
          );
        })}
        {loading ? (
          <SkeletonC width='15%' height='45px' className={styles.skeleton} />
        ) : (
          featuresArray?.length > minShowData && (
            <Buttonc
              type='button'
              btnType='link'
              label={showMore ? 'See Less' : 'See All'}
              onClick={() => {
                showFeature();
                if (type === 'investor') {
                  SeeAllFeatures({
                    buttonLabel: showMore ? 'See Less' : 'See All',
                    propertySFID: objPropertyDetails?.propertySFID,
                    propertyId: objPropertyDetails?.propertyId,
                    shareId: propertyId || '',
                    pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                    opportunitySFID: objPropertyDetails?.opportunitySFID,
                    linkCId: cid,
                    linkEmailId: eq,
                    ...(mobileNumber && { mobileNumber: mobileNumber }),
                  });
                }
              }}
              className={styles.link}
              tabIndex={25}
            />
          )
        )}
      </div>
    </div>
  );
};

export default React.memo(PropertyFeatures);
